import React,{useState} from 'react';
import Modal from '@material-ui/core/Modal';
import {Tools} from './Tools';
import {Styles} from './Styles';
import Header from './Header';
import Top from "./Top";
import Board from "./Board";
import Yesno from "./Yesno";
import Guide from "./Guide";
import Death from "./Death";
import Tweet from "./Tweet";
import {Inc,Play} from "./Inc";
//import Ajax from './Ajax';
//import Loading from './Loading';

interface Props {
    uid:string,
    save(id:string):void,
}


const Main = (props:Props)=> {
    const classes = Styles.base();
    //const [mode,setMode] = useState("death");
    //const [isModal,setIsModal] = useState(false);
    //const [isYesno,setIsYesno] = useState(false);

    const defPlay:Play = Inc.defaultPlay();
    const [states,setStates] = useState({
        mode: "top",
        play: defPlay,
        isModal: false,
        isYesno: false,
    });

    const move = (newMode:string) =>{
        setStates({...states,mode:newMode});
    }
    const die = (play:Play)=>{
        setStates({...states,mode:"death",play:play});
    }
    const goTop = ()=>{
        if(states.mode!=="board"){
            setStates({...states,mode:"top"});
        } else {
            setStates({...states,isYesno:true});
        }
    }
  
    const goGuide = ()=>{
        setStates({...states,isModal:true});
    }
  
    const handleModalClose = ()=>{
        setStates({...states,isModal:false});
    }

    const cancelYes = ()=>{
        setStates({...states,isYesno:false,mode:"top"});
    }
    const cancelNo = ()=>{
        setStates({...states,isYesno:false});
    }
    
    const end = ()=>{
        setStates({
            mode: "top",
            play: defPlay,
            isModal: false,
            isYesno: false,
        });    
    }
    
    return (
        <React.Fragment>
            <Header top={goTop} guide={goGuide}/>

        {states.mode==="top" &&
            <Top uid={props.uid} move={move} save={props.save}/>
        }
        {states.mode==="board" &&
            <Board uid={props.uid} move={move} die={die} save={props.save}/>
        }
        {states.mode==="death" &&
            <Death uid={props.uid} move={move} play={states.play}/>
        }
        {states.mode==="tweet" &&
            <Tweet uid={props.uid} play={states.play} end={end}/>
        }

            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={states.isModal}
                onClose={handleModalClose}
            >
                <div style={Tools.getModalStyle()} className={classes.modal}>
                    <Guide close={handleModalClose}/>
                </div>
            </Modal>
            <Yesno mes="中断？" yes={cancelYes} no={cancelNo} isOpen={states.isYesno}/>
        </React.Fragment>
	);
}

export default Main;
